module.exports = __webpack_public_path__ + "static/media/cancel.a7754b9f.svg";